import { saveState, loadState } from "./../utils/localStorage";
import throttle from "lodash/throttle";
import allReducers from "./../modules/reducers";
import { createStore } from "redux";

const configureStore = middleware => {
  const persistedState = loadState();
  const store = createStore(allReducers, persistedState, middleware);

  store.subscribe(
    throttle(() => {
      saveState({
        user: store.getState().user,
        toolkit: store.getState().toolkit,
        analytics: store.getState().analytics,
        office: store.getState().office,
        kpiMaster: store.getState().kpiMaster,
        mappingMaster: store.getState().mappingMaster,
        orgChart: store.getState().orgChart,
        trivia:store.getState().trivia,
        // item: store.getState().item
        // mapGender : store.getState().mapGender,
        // mapPositions : store.getState().mapPositions,
        // mapPerformance : store.getState().mapPerformance
        sortFilterParams: store.getState().sortFilterParams,
        dani: store.getState().dani,
        maturityModel:store.getState().maturityModel
      });
    }),
    1000
  );

  return store;
};

export default configureStore;
